import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import loginImage from '../assets/images/login-image.png';
import logo from '../assets/images/logo-1.svg';
import { useNavigate } from 'react-router-dom';
import ReactLoading from 'react-loading';

const Signin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [cooldown, setCooldown] = useState(false);

  const validateEmail = (email: string): boolean => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const handleSendOtp = async () => {
    if (!email) {
      toast.error('Please provide a valid email!');
      return;
    }

    if (!validateEmail(email)) {
      toast.error('Invalid email format!');
      return;
    }
    if (loading || cooldown) {
      return;
    }
    setCooldown(true);
    setLoading(true);

    try {
      const response = await fetch('https://pamsapi.vofoxsolutions.com/api/Account/GenerateOtpAsync', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        const responseData = await response.json();
        if (!responseData.isRegisteredUser) {
          toast.success('You are not Registered yet');
        }

        setTimeout(() => {
          navigate('/register', {
            state: {
              email,
              otpSent: true,
              isRegisteredUser: responseData.isRegisteredUser,
            },
          });
        }, 1500);
      } else {
        toast.error('Failed to generate OTP!');
      }
    } catch (error) {
      toast.error('Something went wrong while generating OTP!');
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      setTimeout(() => {
        setCooldown(false);
      }, 3000);
    }
  };


  const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    handleSendOtp();
  };
  return (
    <div className="content-wrapper select-none">
      <main>
        <div className="mx-auto max-w-screen-2xl h-screen flex items-center p-4 md:p-6 2xl:p-10">
          <div>
            <div className="flex flex-wrap items-center">
              <div className="hidden w-full h-full lg:block lg:w-3/5">
                <div className="px-26 py-17.5 text-center">
                  <span className="mt-15 inline-block">
                    <img className="h-full w-full object-cover" src={loginImage} alt="illustration" />
                  </span>
                </div>
              </div>

              <div className="w-full lg:w-2/5">
                <div className="w-full lg:w-3/4 p-4 sm:p-12.5 xl:p-17.5 m-auto">
                  <a className="mb-8 inline-block" href="">
                    <img src={logo} alt="Logo" />
                  </a>

                  <h2 className="mb-9 mt-3 text-3xl font-semibold text-dark">Sign in to your account</h2>

                  <form onSubmit={handleFormSubmit}>
                    <div className="mb-6">
                      <div className="relative">
                        <input
                          type="email"
                          placeholder="Enter your email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          className="w-full rounded-lg bg-slate-50 py-4 pl-6 pr-10 outline-none focus:border-blue focus-visible:shadow-none"
                        />
                      </div>
                    </div>

                    <div className="mb-5">
                      <button
                        type="button"
                        onClick={handleSendOtp}
                        className="w-full cursor-pointer bg-blue-600 shadow-lg shadow-blue-300/50 rounded-lg border border-primary p-4 font-medium text-white transition hover:bg-blue-500 relative flex justify-center items-center"
                        disabled={loading} // Disable the button during loading
                        style={{ height: '50px' }} // Ensure button height is fixed
                      >
                        {loading ? (
                          <ReactLoading type="spin" color="#fff" height={24} width={24} />
                        ) : (
                          'Send OTP'
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <ToastContainer />
    </div>
  );
};

export default Signin;
